import { getNextEvent } from "core-integration/src/store/events/reducers";
import { getTransferState } from "core-integration/src/store/squad/reducers";
import { BasicScoreboard } from "plos/src/components/Scoreboard";
import { CostScoreboard } from "plos/src/components/Scoreboard/CostScoreboard";
import useScoreboard from "plos/src/components/Scoreboard/useScoreboard";
import { Alert } from "plos/src/components/alerts";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ChipList from "../../Chips/ChipList";
import { costWrapper } from "./transfersScoreboard.css";

const TransfersScoreboard = () => {
  const { t } = useTranslation("transfers");
  const {
    currencyDivisor,
    elementTypesByPosition,
    proposedElements,
    toSpend,
    isNeedElements,
    isBudgetExceeded,
  } = useScoreboard();

  const nextEvent = useSelector(getNextEvent);
  const transfersState = useSelector(getTransferState);

  const sharedProps = {
    currencyDivisor,
    elementTypesByPosition,
    proposedElements,
    toSpend,
    isNeedElements,
    isBudgetExceeded,
  };

  if (!transfersState) {
    return null;
  }

  if (!nextEvent) {
    return (
      <div data-variant={"transfers-basic"}>
        <BasicScoreboard {...sharedProps} />
      </div>
    );
  }

  if (transfersState.status === "cost") {
    return (
      <div className={costWrapper}>
        <ChipList chipsShown="transfer" />
        <CostScoreboard {...sharedProps} />
      </div>
    );
  }

  return (
    <>
      <div data-variant={"transfers-basic"}>
        <BasicScoreboard {...sharedProps} />
      </div>
      <Alert isCentered isInline>
        {t(
          "transfersScoreboard.unlimitedTransfers",
          "You can make unlimited free transfers before the {{eventName}} deadline",
          { eventName: nextEvent.name },
        )}
      </Alert>
    </>
  );
};

export default TransfersScoreboard;
